const special = {
    'a': /[àáâãäåăą]/g,
    'A': /[ÀÁÂÃÄÅĂĄ]/g,
    'c': /[ćčç]/g,
    'C': /[ĆČÇ]/g,
    'd': /[ďđ]/g,
    'D': /[ĎÐ]/g,
    'e': /[èéêëěę]/g,
    'E': /[ÈÉÊËĚĘ]/g,
    'g': /[ğ]/g,
    'G': /[Ğ]/g,
    'i': /[ìíîï]/g,
    'I': /[ÌÍÎÏ]/g,
    'l': /[ĺľł]/g,
    'L': /[ĹĽŁ]/g,
    'n': /[ñňń]/g,
    'N': /[ÑŇŃ]/g,
    'o': /[òóôõöøő]/g,
    'O': /[ÒÓÔÕÖØ]/g,
    'r': /[řŕ]/g,
    'R': /[ŘŔ]/g,
    's': /[ššş]/g,
    'S': /[ŠŞŚ]/g,
    't': /[ťţ]/g,
    'T': /[ŤŢ]/g,
    'u': /[ùúûůüµ]/g,
    'U': /[ÙÚÛŮÜ]/g,
    'y': /[ÿý]/g,
    'Y': /[ŸÝ]/g,
    'z': /[žźż]/g,
    'Z': /[ŽŹŻ]/g,
    'th': /[þ]/g,
    'TH': /[Þ]/g,
    'dh': /[ð]/g,
    'DH': /[Ð]/g,
    'ss': /[ß]/g,
    'oe': /[œ]/g,
    'OE': /[Œ]/g,
    'ae': /[æ]/g,
    'AE': /[Æ]/g
}

const tidy = {
    ' ': /[\xa0\u2002\u2003\u2009]/g,
    '*': /[\xb7]/g,
    '\'': /[\u2018\u2019]/g,
    '"': /[\u201c\u201d]/g,
    '...': /[\u2026]/g,
    '-': /[\u2013]/g,
//  '--': /[\u2014]/g,
    '&raquo;': /[\uFFFD]/g
}

const walk = (string, replacements) => {
    let result = string;
    for (let key in replacements) {
        result = result.replace(replacements[key], key);
    }
    return result;
}

export const standardize = str => walk(str, special)

export function substitute(str, object, regexp){
    return String(str).replace(regexp || (/\\?\{([^{}]+)\}/g), function(match, name){
        if (match.charAt(0) == '\\') return match.slice(1);
        return (object[name] != null) ? object[name] : '';
    });
}